<template>
    <div>
        <div class>
            <Steps :active="3" align-center>
                <Step :title="$t('offering.offbase')" @click.native="on_click('offbaseAdd')" />
                <Step :title="$t('offering.offeringResources')" @click.native="on_click('offeringResourcesAdd')" />
                <Step :title="$t('offering.offconditionAdd')" @click.native="on_click('offconditionAdd')" />
                <Step :title="$t('offering.offnoticeAdd')" />
                <Step :title="$t('offering.offpriceAdd')" @click.native="on_click('offpriceAdd')" />
                <Step :title="$t('offering.offinvestAdd')" @click.native="on_click('offinvestAdd')" />
                <Step :title="$t('offering.offabilityAdd')" @click.native="on_click('offabilityAdd')" />
            </Steps>
        </div>
        <br/>
        <div class='divMessage'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ message }}</div>
        <br/>
        <el-card class="aui-card--fill"
                 shadow="never">
            <el-form ref="dataForm"  :inline="true" :model="dataForm" :rules="rules"  >
                <el-row>
                    <el-col :span="1"><div class="grid-content" /></el-col>
                </el-row>
                <el-row>
                    <el-col :span="1"><div class="grid-content" /></el-col>
                    <el-col :span="3">
                        <el-form-item label="通知方式" prop="notice"></el-form-item>
                    </el-col>
                    <el-col :span="2">
                        <el-form-item >
                            <el-checkbox v-model="dataForm.noticeEmailFalg" @change="handleEmailCheck">邮件</el-checkbox>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="设置模板内容"></el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-select v-bind:disabled="disableEmail" v-model="dataForm.emailTemplateId" placeholder="请选择" @change="emailContentChange">
                            <el-option
                                    v-for="item in options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>

                </el-row>
                <el-row>
                    <el-col :span="10"><div class="grid-content" /></el-col>
                    <el-col :span="12">
                        <el-input v-bind:disabled="disableEmailContent" v-model="dataForm.emailContent" type="textarea" :rows="12" ></el-input>
                    </el-col>
                </el-row>
                <br/>
                <br/>
                <el-row>
                    <el-col :span="1"><div class="grid-content" /></el-col>
                    <el-col :span="3">
                        <div class="grid-content" />
                    </el-col>
                    <el-col :span="2">
                        <el-form-item >
                            <el-checkbox v-model="dataForm.noticeLetterFlag"  @change="handleLetterCheck">站内信</el-checkbox>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="设置模板内容"></el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-select v-bind:disabled="disableLetter" v-model="dataForm.letterTemplateId" placeholder="请选择" @change="letterContentChange">
                            <el-option
                                    v-for="item in options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>

                </el-row>
                <el-row>
                    <el-col :span="10"><div class="grid-content" /></el-col>
                    <el-col :span="12">
                        <el-input v-bind:disabled="disableLetterContent" v-model="dataForm.letterContent" type="textarea" :rows="12" ></el-input>
                    </el-col>
                </el-row>
                <br/>
                <br/>
                <el-row>
                    <el-col :span="1"><div class="grid-content" /></el-col>
                    <el-col :span="3">
                        <div class="grid-content" />
                    </el-col>
                    <el-col :span="2">
                        <el-form-item >
                            <el-checkbox v-model="dataForm.noteSmsFlag" @change="handleSmsCheck">短信</el-checkbox>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="设置模板内容"></el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-select v-bind:disabled="disableSms" v-model="dataForm.smsTemplateId" placeholder="请选择" @change="smsContentChange">
                            <el-option
                                    v-for="item in options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>

                </el-row>
                <el-row>
                    <el-col :span="10"><div class="grid-content" /></el-col>
                    <el-col :span="12">
                        <el-input v-bind:disabled="disableSmsContent" v-model="dataForm.smsContent" type="textarea" :rows="12" ></el-input>
                    </el-col>
                </el-row>
            </el-form>
        </el-card>
        <div>
            <el-row style="float:right; margin-bottom: 60px;">
                <el-col :span="16"><div class="grid-content" /></el-col>
                <el-button v-if="$hasPermission('learning:offeringinfo:offeringNoticeSave') && $hasPermission('learning:offeringinfo:offeringPriceSave')"
                           @click="btnSaveNextStep"  type="primary">{{ $t("course.saveAndNext") }}</el-button>
                <el-button v-if="$hasPermission('learning:offeringinfo:offeringNoticeSave')"
                           @click="btnSave"  type="primary">{{ $t("course.save") }}</el-button>
                <ZElButton @click="btnCancel" >{{ $t("course.cancel") }}</ZElButton>
            </el-row>
        </div>
    </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
// 基本信息   offbaseAdd
// 报名条件   offconditionAdd
// 报名通知   offnoticeAdd
// 价格相关   offpriceAdd
// 调查问卷   offinvestAdd
// 能力项设置 offabilityAdd
import Steps from '../../common/steps/index'
import Step from '../../common/steps/src/step'
import ZElButton from '../../common/button/index'
export default {
// import引入的组件需要注入到对象中才能使用
  components: { Steps, Step, ZElButton },
  props: ['message', 'passOfferingId'],
  inject: ['toTop'],
  data () {
    return {
      dataForm: {
        offeringId: '',
        emailTemplateId: 1, // Email值
        letterTemplateId: 1, // 站内信
        smsTemplateId: 1, // 短信

        emailContent: 'defaultTemp',
        letterContent: 'defaultTemp',
        smsContent: 'defaultTemp',

        noticeEmailFalg: true,
        noticeLetterFlag: true,
        noteSmsFlag: true
      },
      disableEmail: false,
      disableEmailContent: false,
      disableLetter: false,
      disableLetterContent: false,
      disableSms: false,
      disableSmsContent: false,
      options: [{
        value: 1,
        label: '默认模板'
      }, {
        value: 2,
        label: '模板2'
      }, {
        value: 3,
        label: '模板3'
      }],
      openTemp: {
        1: 'defaultTemp',
        2: 'Temp2',
        3: 'Temp3'
      },
      value: '',
      rules: {
        notice: [
          { required: true, message: '', trigger: 'change' }
        ]
      }
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    // TODO 点击保存并下一步进入页面初始化数据
    this.$eventHub.$on('offbaseAdd', data => {
      this.again()
    })
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    console.log('mounted')
  },
  beforeCreate () {
    console.log('beforeCreate')
  }, // 生命周期 - 创建之前
  beforeMount () {
    console.log('beforeMount')
  }, // 生命周期 - 挂载之前
  beforeUpdate () {
    console.log('beforeUpdate')
  }, // 生命周期 - 更新之前
  updated () {
    console.log('updated')
  }, // 生命周期 - 更新之后
  beforeDestroy () {
    console.log('beforeDestroy')
  }, // 生命周期 - 销毁之前
  destroyed () {
    console.log('destroyed')
  }, // 生命周期 - 销毁完成
  activated () {
    if (this.$route.query.offeringId !== undefined && this.$route.query.offeringId !== '') {
      // #TODO 再次进入页面初始化数据
      console.log('再次进入 abilityItems')
      console.log(this.$route.query.offeringId)
      this.init(this.$route.query.offeringId)
    }
  },
  // 方法集合
  methods: {
    // 设置初始化为空
    again () {
      // TODO data 数据设置为空
    },
    // 初始化数据
    init (offeringId) {
      this.again()
      this.getOfferingBaseInfo(offeringId)
    },
    getOfferingBaseInfo (offeringId) {
      this.dataForm.offeringId = offeringId
      if (this.dataForm.offeringId === null || this.dataForm.offeringId === '') {
        return
      }
      this.$request.get('/learning/base/offeringinfo/get/' + this.dataForm.offeringId
      ).then((res, total, code, data) => {
        this.dataForm = data.data
        if (this.dataForm.noticeEmailFalg === 'true') {
          this.dataForm.noticeEmailFalg = true
        } else {
          this.dataForm.noticeEmailFalg = false
        }
        if (this.dataForm.noticeLetterFlag === 'true') {
          this.dataForm.noticeLetterFlag = true
        } else {
          this.dataForm.noticeLetterFlag = false
        }
        if (this.dataForm.noteSmsFlag === 'true') {
          this.dataForm.noteSmsFlag = true
        } else {
          this.dataForm.noteSmsFlag = false
        }
        this.handleEmailCheck(this.dataForm.noticeEmailFalg)
        this.handleLetterCheck(this.dataForm.noticeLetterFlag)
        this.handleSmsCheck(this.dataForm.noteSmsFlag)
      }).catch((err) => {
        console.log(err)
      })
    },
    // 勾选Email时触发
    handleEmailCheck (val) {
      if (val) {
        this.disableEmail = false
        this.disableEmailContent = false
      } else {
        this.disableEmail = true
        this.disableEmailContent = true
      }
    },
    // 勾选站内信时触发
    handleLetterCheck (val) {
      if (val) {
        this.disableLetter = false
        this.disableLetterContent = false
      } else {
        this.disableLetter = true
        this.disableLetterContent = true
      }
    },
    // 勾选短信时触发
    handleSmsCheck (val) {
      if (val) {
        this.disableSms = false
        this.disableSmsContent = false
      } else {
        this.disableSms = true
        this.disableSmsContent = true
      }
    },
    // Email 下拉框选择后触发
    emailContentChange (val) {
      this.dataForm.emailContent = this.openTemp[val]
    },

    // 站内信 下拉框选择后触发
    letterContentChange (val) {
      this.dataForm.letterContent = this.openTemp[val]
    },

    // 短信 下拉框选择后触发
    smsContentChange (val) {
      this.dataForm.smsContent = this.openTemp[val]
    },
    // 判断是否勾选
    isCheck () {
      return this.dataForm.noticeEmailFalg === false && this.dataForm.noticeLetterFlag === false && this.dataForm.noteSmsFlag === false
    },
    // 验证判断
    isCheckNotice () {
      console.log('isCheckNotice')
      console.log(this.dataForm)
      if (this.isCheck()) {
        this.$message({
          message: this.$t('offering.signUpNoticeError'),
          type: 'error',
          duration: 2000
        })
        return false
      }
      if (this.dataForm.noticeEmailFalg === true) {
        if (this.dataForm.emailContent.trim() === '') {
          this.$message({
            message: this.$t('offering.signUpNoticeConError'),
            type: 'error',
            duration: 2000
          })
          return false
        }
      }
      if (this.dataForm.noticeLetterFlag === true) {
        console.log('this.dataForm.noticeLetterFlag')
        console.log(this.dataForm)
        if (this.dataForm.letterContent.trim() === '') {
          this.$message({
            message: this.$t('offering.signUpNoticeConError'),
            type: 'error',
            duration: 2000
          })
          return false
        }
      }
      if (this.dataForm.noteSmsFlag === true) {
        if (this.dataForm.smsContent.trim() === '') {
          this.$message({
            message: this.$t('offering.signUpNoticeConError'),
            type: 'error',
            duration: 2000
          })
          return false
        }
      }
      return true
    },
    // 保存方法
    btnSave () {
      this.dataForm.offeringId = this.passOfferingId
      if (this.isCheckNotice()) {
        this.$request.put(`/learning/base/offeringinfo/offeringNoticeUpdate`,
          this.dataForm
        ).then((res, total, code, data) => {
          if (data.code === 13000000) {
            this.$message({
              message: this.$t(data.msg),
              type: 'error',
              duration: 2000
            })
          } else if (data.code === 1) {
            this.$message({
              message: this.$t('prompt.success'),
              type: 'success',
              duration: 2000
            })
            this.tabRemove()
            this.$router.push({
              name: 'learning-offering-offeringlist'
            })
          }
        }).catch((err) => {
          console.log(err)
        })
      }
    },
    // 保存并下一步
    btnSaveNextStep () {
      console.log('btnSaveNextStep')
      console.log(this.dataForm)
      this.dataForm.offeringId = this.passOfferingId
      if (this.isCheckNotice()) {
        this.$request.put(`/learning/base/offeringinfo/offeringNoticeUpdate`,
          this.dataForm
        ).then((res, total, code, data) => {
          if (data.code === 13000000) {
            this.$message({
              message: this.$t(data.msg),
              type: 'error',
              duration: 2000
            })
          } else if (data.code === 1) {
            this.$message({
              message: this.$t('prompt.success'),
              type: 'success',
              duration: 2000
            })
            this.sendMsg()
          }
        }).catch((err) => {
          console.log(err)
        })
      }
    },
    // 向父页面传递消息 跳转下一页面
    sendMsg () {
      this.toTop()
      this.$emit('onShowModer', 'offpricesend')
    },
    // 向父页面传递消息 保存页面
    sendSave () {
      this.$emit('onShowModer', 'offpriceSave')
    },
    // 点击导航跳转页面
    on_click (e) {
      this.$confirm('离开本页将不保存当前正在编辑的数据, 确定离开? ', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$emit('onShowModer', e)
      }).catch((err) => {
        console.log(err)
      })
    },
    // 取消按钮
    btnCancel () {
      this.$confirm('离开本页将不保存当前正在编辑的数据, 确定离开? ', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.tabRemove()
      }).catch((err) => {
        console.log(err)
      })
    },
    // 删除当前页面
    tabRemove () {
      let tabName = this.$store.state.contentTabsActiveName
      if (tabName === 'home') {
        return false
      }
      this.$store.state.contentTabs = this.$store.state.contentTabs.filter(item => item.name !== tabName)
      if (this.$store.state.contentTabs.length <= 0) {
        this.$store.state.sidebarMenuActiveName = this.$store.state.contentTabsActiveName = 'home'
        return false
      }
      // 当前选中tab被删除
      if (tabName === this.$store.state.contentTabsActiveName) {
        this.$router.push({ name: this.$store.state.contentTabs[this.$store.state.contentTabs.length - 1].name })
      }
    }
  }
}
</script>
<style lang='scss' scoped>
    // @import url(); 引入公共css类
    .grid-content {
        border-radius: 4px;
        min-height: 20px;
    }
</style>
